import React, { createContext, useContext, useState } from 'react';

const LabelWidthContext = createContext<number>(0);
const UpdateLabelWidthContext = createContext<(labelWidth: number) => void>(() => {});

type ProviderProps = {
  minLabelWidth?: number;
  children?: React.ReactNode;
}

function ParameterGroupProvider ({ minLabelWidth, children } : ProviderProps) {
  const [labelWidth, setLabelWidth] = useState(minLabelWidth ?? 0);

  return (
    <LabelWidthContext.Provider value={labelWidth}>
      <UpdateLabelWidthContext.Provider value={setLabelWidth}>
        {children}
      </UpdateLabelWidthContext.Provider>
    </LabelWidthContext.Provider>
  );
}

const useLabelWidth = (): [number, (labelWidth: number) => void] => {
  return [useContext(LabelWidthContext), useContext(UpdateLabelWidthContext)];
};

export { useLabelWidth };

export default ParameterGroupProvider;